<template>
  <div class="text-left">
    <h4 class="mt-4 text-left text-dark-gray sm:mt-2">
      Enter your eCheck payment information.
    </h4>
    <p
      v-if="!show_po_box"
      class="mb-6 text-xxs font-bold uppercase text-gray-over-dark"
    >
      Search for your address below, then select an address from the dropdown
      menu to continue.
    </p>
    <p
      v-else
      class="mb-6 text-xxs font-bold uppercase text-gray-over-dark"
    >
      Enter your PO Box details below to continue.
    </p>
    <div class="sm:mt-2 sm:flex sm:gap-6">
      <div class="w-full">
        <form-field
          id="email"
          label="Email"
          :value="email"
          placeholder="Enter your email address"
          :on-input="handleEmailAddress"
          name="email"
          pattern="\d*"
        />
        <div class="text-left">
          <!-- <places-auto-complete 
        id="physical_address"
        label="ADDRESS"
        @placechanged="onPhysicalAddressChange"
        @placecleared="onClearPhysical"
        placeholder="Search"
        :countries="['US']"
        :types="'street_address'"
      /> -->
          <google-autocomplete-places
            v-if="!show_po_box"
            label="ADDRESS"
            @placechanged="onPhysicalAddressChange"
          />
          <template v-if="show_po_box">
            <form-field
              id="echeck_po_box"
              label="PO Box Number"
              :value="po_box.street1"
              placeholder="Enter your PO Box number (digits only)"
              :on-input="handlePOBox"
              name="echeck_po_box"
              pattern="\d*"
            />
            <form-field
              id="echeck_city"
              label="City"
              :value="po_box.city"
              placeholder="Enter city"
              :on-input="handlePOBox"
              name="echeck_city"
            />
            <form-field
              id="echeck_state"
              label="State"
              :value="po_box.state"
              placeholder="Enter two-letter state abbreviation"
              :on-input="handlePOBox"
              name="echeck_state"
            />
            <form-field
              id="echeck_postal_code"
              label="Postal Code"
              :value="po_box.postal_code"
              placeholder="Enter postal code"
              :on-input="handlePOBox"
              name="echeck_postal_code"
            />
            <dropdown-select-payment
              :options="countryOptions"
              :default="'United States'"
              :on-input="handlePOBox"
              label="Country"
              name="echeck_country"
            />
          </template>
          <div class="relative mt-2 flex items-start">
            <div class="flex h-6 items-center">
              <input
                id="echeck-show-po-box"
                v-model="show_po_box"
                name="echeck-show-po-box"
                type="checkbox"
                class="form-checkbox h-4 w-4 cursor-pointer rounded border-gray-300 text-yellow-500"
              />
            </div>
            <div class="ml-2 text-sm leading-6">
              <label
                for="echeck-show-po-box"
                class="cursor-pointer text-xs text-body-color"
                >Use a PO Box number instead</label
              >
            </div>
          </div>
          <div class="h-60" />
        </div>
        <p
          v-if="data.errors"
          class="-mt-3 mb-2 text-3xs text-red-500 sm:hidden"
        >
          Account numbers do not match
        </p>
      </div>
    </div>
    <p
      v-if="data.errors"
      class="-mt-3 hidden text-3xs text-red-500 sm:block"
    >
      Account numbers do not match
    </p>
  </div>
</template>
<script>
import FormField from '../../FormField.vue';
import { isEmail } from '@/common/validators.js';
// import PlacesAutoComplete from "@/components/PlacesAutoComplete.vue";
import GoogleAutocompletePlaces from '@/components/GoogleAutocompletePlaces.vue';
import DropdownSelectPayment from '@/components/DropdownSelectPayment.vue';

export default {
  name: 'ECheck',
  components: {
    'form-field': FormField,
    // PlacesAutoComplete,
    GoogleAutocompletePlaces,
    DropdownSelectPayment,
  },
  props: {
    data: Object,
    firstTime: {
      type: [Number, Boolean],
      required: true,
    },
    stepName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      email: '',
      address: '',
      show_po_box: false,
      po_box: {
        street1: '',
        city: '',
        state: '',
        postal_code: '',
        country: '',
      },
      countryOptions: ['United States', 'Canada'],
    };
  },
  computed: {
    isValidForm: function () {
      return this.isValidEmailAddress() && this.address !== '';
    },
    newPaymentMethodType() {
      return this.$store.state.payments?.newPaymentMethodType;
    },
  },
  watch: {
    isValidForm: function (isValid) {
      this.$store.commit('toggleDisabledButton', {
        bool: !isValid,
        source: 'Payment-3 ECheck #5',
      });
    },
    stepName: function (val) {
      // if (val === "Payment-3" && !this.firstTime) {
      if (val === 'Payment-3' && this.newPaymentMethodType == 'echeck') {
        if (this.email?.length > 0 && this.address) {
          this.onUpdate();
        } else {
          this.toggleButton(true);
        }
      }
    },
  },
  mounted() {
    this.$store.commit(
      'addFormDebugMessage',
      'Payment-3 | ECheck | ECheck mounted'
    );
    if (!this.isValidForm) {
      this.$store.commit('toggleDisabledButton', {
        bool: true,
        source: 'Payment-3 ECheck #1',
      });
    } else {
      this.$store.commit('toggleDisabledButton', {
        bool: false,
        source: 'Payment-3 ECheck #2',
      });
    }
  },
  methods: {
    onClearPhysical: function () {
      this.physicalAddress = undefined;
    },
    onPhysicalAddressChange: function (e) {
      console.log('onPhysicalAddressChange');
      console.dir(e);
      // this.address = e.address;
      this.address = e;
      this.onUpdate();
    },
    isValidEmailAddress() {
      return isEmail(this.email);
    },
    handleEmailAddress(e) {
      this.email = e.target.value;
      if (!isEmail(this.email))
        this.$store.commit('toggleDisabledButton', {
          bool: true,
          source: 'Payment-3 ECheck #3',
        });
      this.onUpdate();
    },
    handlePOBox(e) {
      switch (e?.target?.name) {
        case 'echeck_po_box':
          this.po_box.street1 = e?.target?.value;
          break;
        case 'echeck_city':
          this.po_box.city = e?.target?.value;
          break;
        case 'echeck_state':
          this.po_box.state = e?.target?.value?.toUpperCase();
          break;
        case 'echeck_postal_code':
          this.po_box.postal_code = e?.target?.value;
          break;
      }
      if (this.countryOptions?.includes(e)) {
        this.po_box.country = e;
      }
      this.onUpdate();
    },
    formatCountry(country) {
      if (country === 'United States') {
        return 'US';
      }
      if (country === 'Canada') {
        return 'CA';
      }
      return country;
    },
    onUpdate() {
      if (this.show_po_box) {
        this.onUpdatePOBox();
      } else {
        this.onUpdateAddress();
      }
    },
    onUpdatePOBox() {
      this.address = '';
      let body = {
        is_active: true,
        is_type: this.$store.state.payments.newPaymentMethodType,
        street1:
          this.po_box?.street1?.length > 0
            ? `PO Box ${this.po_box.street1}`
            : null,
        city: this.po_box?.city || null,
        state: this.po_box?.state || null,
        country: this.formatCountry(this.po_box?.country) || 'US',
        postal_code: this.po_box?.postal_code || null,
        email_address: this.email,
      };
      this.updateOnboardingPacket(body);

      if (
        this.po_box?.street1?.length > 0 &&
        this.po_box?.city?.length > 0 &&
        this.po_box?.state?.length > 0 &&
        this.po_box?.postal_code?.length > 0
      ) {
        this.toggleButton(false);
      } else {
        this.toggleButton(true);
      }
    },
    onUpdateAddress() {
      this.po_box = {
        street1: '',
        city: '',
        state: '',
        postal_code: '',
        country: '',
      };
      let street1Val = `${this.address?.street_number} ${this.address?.route}`;
      let body = {
        is_active: true,
        is_type: this.$store.state.payments.newPaymentMethodType,
        street1: street1Val || null,
        city: this.address?.locality || null,
        state: this.address?.administrative_area_level_1 || null,
        country: this.formatCountry(this.address?.country) || null,
        postal_code: this.address?.postal_code || null,
        email_address: this.email,
      };
      this.updateOnboardingPacket(body);

      if (street1Val?.length > 0) {
        this.toggleButton(false);
      } else {
        this.toggleButton(true);
      }
    },
    toggleButton(value) {
      this.$store.commit('toggleDisabledButton', {
        bool: value,
        source: 'Payment-3 ECheck #4',
      });
    },
    updateOnboardingPacket(body) {
      this.$store.dispatch('payments/setPaymentBody', {
        payment_method: body,
      });
    },
  },
};
</script>

<style>
.pac-container:after {
  background-image: none;
  display: none;
}

.pac-icon {
  display: none;
}

.pac-item {
  border: none;
  padding: 9px 14px;
  line-height: 21px;
  font: inherit;
  cursor: pointer;
  @apply text-gray-over-dark;
}

.pac-item-query {
  font: inherit;
  @apply text-gray-over-dark;
}

.pac-matched {
  font: inherit;
  @apply text-gray-over-dark;
}

.pac-container {
  margin-top: -7px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  box-shadow: none;
  border: none;
  border: 1px solid black;
  border-top: 0;
  width: 100%;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-sizing: content-box;
  @apply text-gray-over-dark;
}

.google-autocomplete {
  outline: none;
  border-radius: 5px;
  padding: 16px 36px 16px 16px;
}

.google-autocomplete:focus {
  outline: none;
  border: 1px solid black !important;
}

.google-autocomplete:hover {
  border: 1px solid #c7cbdb;
}

.google-autocomplete:focus + .magnifying-glass > path,
.google-autocomplete:focus + .magnifying-glass > circle {
  stroke: #313545;
}
.magnifying-glass {
  position: absolute;
  top: 2px;
  right: 17px;
}
.close-icon {
  position: absolute;
  top: 4px;
  right: 17px;
}

.form-checkbox:checked {
  border-color: transparent;
  background-color: currentColor !important;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
